import React, { Component } from "react";
import { SortAdornment } from "../../../../shared/SortAdornment/SortAdornment";
import { ORDER_TYPES } from "../../../../consts/api";
class ItemSales extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      globalLang: languageData.global,
      reportData: props.reportData ? props.reportData : [],
      languageData: languageData.business_insights,
      sortBy: null,
      sortDir: null,
    };

    window.onscroll = () => {
      return false;
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};

    if (
      nextProps.reportData !== undefined &&
      nextProps.reportData !== prevState.reportData
    ) {
      returnState.reportData = nextProps.reportData;
    }

    return returnState;
  }

  onSort = (field) => {
    const newSortDir =
      this.state.sortBy === field && this.state.sortDir === ORDER_TYPES.asc
        ? ORDER_TYPES.desc
        : ORDER_TYPES.asc;
    this.setState({ sortBy: field, sortDir: newSortDir });
    this.props.handleSort(field, newSortDir);
  };

  renderSortWrap = (field, label) => (
    <SortAdornment
      value={this.state.sortBy === field ? this.state.sortDir : undefined}
      onToggle={() => this.onSort(field)}
    >
      {label}
    </SortAdornment>
  );

  render() {
    return (
      <div className="table-responsive clients-table">
        <table className="table-updated setting-table table-min-width no-td-border no-hover">
          <thead className="table-updated-thead">
            {
              <tr>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "item",
                    this.state.reportData?.report_header?.item,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "category",
                    this.state.reportData?.report_header?.category,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "unit_used",
                    this.state.reportData?.report_header?.unit_used,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "unit_sold",
                    this.state.reportData?.report_header?.unit_sold,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "gross_sales",
                    this.state.reportData?.report_header?.gross_sales,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "discount_percentage",
                    this.state.reportData?.report_header?.discount_percentage,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap("redeemed_amount", "Item Redemption")}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap("adjustment_amount", "Promo Adjustment")}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "net_amount",
                    this.state.reportData?.report_header?.net_amount,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "taxable_amount",
                    this.state.reportData?.report_header?.taxable_amount,
                  )}
                </th>
              </tr>
            }
          </thead>
          <tbody className="ajax_body">
            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length > 0 &&
              this.state.reportData.report_data.map((obj, idx) => {
                return (
                  <tr key={idx} className="table-updated-tr">
                    <td className="table-updated-td item-sales-item-td">
                      {obj.item}
                    </td>
                    <td className="table-updated-td">{obj.category}</td>
                    <td className="table-updated-td">
                      {obj.unit_used}
                      {obj.source_label && (
                        <span className="font-size-12">
                          <br />
                          {obj.source_label}
                        </span>
                      )}
                    </td>
                    <td className="table-updated-td">
                      {obj.unit_sold}
                      {obj.source_label && (
                        <span className="font-size-12">
                          <br />
                          {obj.source_label}
                        </span>
                      )}
                    </td>
                    <td className="table-updated-td">{obj.gross_sales}</td>
                    <td className="table-updated-td">
                      {obj.discount_percentage}
                    </td>
                    <td className="table-updated-td">{obj.redeemed_amount}</td>
                    <td className="table-updated-td">
                      {obj.adjustment_amount}
                    </td>
                    <td className="table-updated-td">{obj.net_amount}</td>
                    <td className="table-updated-td">{obj.taxable_amount}</td>
                  </tr>
                );
              })}

            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length > 0 &&
              this.state.reportData.total && (
                <tr className="table-updated-tr">
                  <td className="table-updated-td bold">Total</td>
                  <td className="table-updated-td bold"></td>
                  <td className="table-updated-td bold">
                    {this.state.reportData.total.unit_used}
                  </td>
                  <td className="table-updated-td bold">
                    {this.state.reportData.total.unit_sold}
                  </td>
                  <td className="table-updated-td bold">
                    {this.state.reportData.total.gross_sales}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.discount_percentage}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.redeemed_amount}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.adjustment_amount}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.net_amount}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.taxable_amount}
                  </td>
                </tr>
              )}

            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length === 0 && (
                <tr className="table-updated-tr">
                  <td
                    className="table-updated-td no-record no-float"
                    colSpan="12"
                  >
                    {this.state.languageData.bi_no_record_found}
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ItemSales;
